import {
  Unit_instance1fbcbse1fwigr as Unit_instance,
  VOID3gxj6tk5isa35 as VOID,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForClass(StorageSettings, 'StorageSettings', StorageSettings);
//endregion
function StorageSettings(delegate) {
  var tmp;
  if (delegate === VOID) {
    // Inline function 'com.russhwolf.settings.localStorage' call
    tmp = localStorage;
  } else {
    tmp = delegate;
  }
  delegate = tmp;
  this.b68_1 = delegate;
}
protoOf(StorageSettings).m2x = function (key) {
  return this.b68_1.removeItem(key);
};
protoOf(StorageSettings).c68 = function (key, value) {
  // Inline function 'com.russhwolf.settings.set' call
  this.b68_1.setItem(key, value);
};
protoOf(StorageSettings).d68 = function (key) {
  // Inline function 'com.russhwolf.settings.get' call
  return this.b68_1.getItem(key);
};
//region block: exports
export {
  StorageSettings as StorageSettings203mesgel706z,
};
//endregion

//# sourceMappingURL=MultiplatformSettings-multiplatform-settings.mjs.map
